import { FC, useState } from 'react';
import { FiltersContext } from './FiltersContext';

export enum Filters {
  IS_OFF = 'IS_OFF',
  IS_CAP = 'IS_CAP',
  IS_NO_CAP = 'IS_NO_CAP',
  IS_OPTIMIZE = 'IS_OPTIMIZE',
}

export const FiltersProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [search, setSearch] = useState('');
  const [filters, setFilters] = useState(new Set<Filters>());

  const toggleFilter = (filter: Filters) => {
    const next = new Set(filters);
    if (next.has(filter)) {
      next.delete(filter);
    } else {
      next.add(filter);
    }
    setFilters(next);
  };

  const clearFilters = () => {
    const next = new Set<Filters>();
    setFilters(next);
  };

  return (
    <FiltersContext.Provider
      value={{
        search,
        setSearch,
        filters,
        toggleFilter,
        clearFilters,
      }}
    >
      {children}
    </FiltersContext.Provider>
  );
};
